import { useEffect, useState } from 'react';

import type { EmbedStrategy } from './types';

// gloss
export const useEmbedStrategy = (): EmbedStrategy | null => {
  const [parentOrigin, setParentOrigin] = useState<string | null>(null);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    try {
      if (document.referrer) {
        const url = new URL(document.referrer);
        setParentOrigin(url.origin);
        return;
      }

      const params = new URLSearchParams(window.location.search);
      const configuredOrigin = params.get('parentOrigin');
      if (configuredOrigin) {
        setParentOrigin(configuredOrigin);
        return;
      }

      if (window.parent !== window) {
        setParentOrigin('*');
        return;
      }

      setParentOrigin(window.location.origin);
    } catch (_e) {
      setParentOrigin('*');
    }
  }, []);

  if (!parentOrigin) {
    return null;
  }

  return {
    type: 'embed',
    parentOrigin,
  };
};
